<template>
      <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" id="menu-toggle" href="#" data-target="#navbar-collapse"><i class="fas fa-bars"></i></a>
        
      </li>
      
      <li class="nav-item d-none d-sm-inline-block">
        <b-link href="/" class="nav-link">Home</b-link>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <b-link href="/contact" class="nav-link">Contact</b-link>
      </li>
    </ul>

    <!-- SEARCH FORM -->
    <Search></Search>

  </nav>
</template>

<script>
import Search from "../components/Search";
export default {
    components : {
        Search
    },
     
  }

</script>
